import dayjs from 'dayjs';
import { CustomerType } from 'api';
import isEmptyNumber from 'utils/phone/isEmptyNumber';
import trimAllSpaces from 'utils/text/trimAllSpaces';
import { getUserDataFromSession } from 'utils/account/getUserDataFromSession';
const toUtcDateOnly = value => {
  if (!value) return undefined;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return new Date(Date.UTC(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate()));
  }
  const valueString = String(value);
  const dateOnlyMatch = valueString.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  }
  const parsedDate = dayjs(valueString);
  if (!parsedDate.isValid()) return undefined;
  return new Date(Date.UTC(parsedDate.year(), parsedDate.month(), parsedDate.date()));
};
const getBirthDateFromForm = (birthDate, isNorwegianLocale) => {
  if (!birthDate) return undefined;
  const match = isNorwegianLocale ? birthDate.match(/^(\d{2})[- /.](\d{2})[- /.](\d{4})$/) : birthDate.match(/^(\d{4})[- /.](\d{2})[- /.](\d{2})$/);
  if (!match) return undefined;
  const [, first, second, third] = match;
  const [year, month, day] = isNorwegianLocale ? [third, second, first] : [first, second, third];
  return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
};
const mapCustomer = (customer, customerType, isNorwegianLocale = false) => {
  let body;
  if (customerType === CustomerType.Person) {
    const userData = getUserDataFromSession();
    const birthDate = toUtcDateOnly(userData?.birthDate) ?? getBirthDateFromForm(customer.personNumber, isNorwegianLocale);
    body = {
      customerType: CustomerType.Person,
      personFirstName: customer.personFirstName?.normalize('NFKC'),
      personLastName: customer.personLastName?.normalize('NFKC'),
      email: customer.email?.trim(),
      phoneNumber: trimAllSpaces(customer.phoneNumber) || undefined,
      dateOfBirth: birthDate,
      customerAddress: customer.billingAddress,
      shippingAddress: customer.shippingAddress ?? undefined,
      receiveInvoicesByEmail: customer.receiveInvoicesByEmail,
      billingEmail: customer.billingEmail?.trim() || undefined,
      socialSecurityNumber: userData?.nin
    };
  } else {
    body = {
      customerType: CustomerType.Company,
      phoneNumber: !isEmptyNumber(customer.phoneNumber) ? trimAllSpaces(customer.phoneNumber) : undefined,
      contactPhoneNumber: !isEmptyNumber(customer.contactPhoneNumber) ? trimAllSpaces(customer.contactPhoneNumber) : undefined,
      customerAddress: customer.billingAddress,
      shippingAddress: customer.shippingAddress ?? undefined,
      contactEmail: customer.contactEmail?.trim(),
      contactName: customer.contactName?.normalize('NFKC'),
      email: customer.email?.trim(),
      organizationName: customer.organizationName?.normalize('NFKC'),
      organizationNumber: customer.organizationNumber,
      receiveInvoicesByEmail: customer.receiveInvoicesByEmail,
      billingEmail: customer.billingEmail?.trim() || undefined
    };
  }
  return body;
};
export default mapCustomer;